import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const BookingLinkRenderer = (props) => {
  return (
    <Link to={`/booking/travel/${props.data.id}`}>{props.value}</Link>
  );
};

BookingLinkRenderer.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }).isRequired,
  value: PropTypes.node
};

export default BookingLinkRenderer;
